"use client"

import Image from "next/image"
import Link from "next/link"
import { useRouter } from "next/navigation"
import { useCallback, useState } from "react"
import { Button } from "../../_components/buttons/button"
import { TextInput } from "../../_components/forms/textInput"
import { GaTag } from "../../_components/gaTag"
import { useApiClient } from "../../_components/hooks/useApiClient"

type LoginPageProps = {
  gaId: string
}

const LoginPage = ({ gaId }: LoginPageProps) => {
  const router = useRouter()
  const [adminMemberIdText, setadminMemberIdText] = useState("")
  const [passwordText, setPasswordText] = useState("")
  const [isAuthFailed, setIsAuthFailed] = useState<boolean>(false)
  const disabledButton = adminMemberIdText === "" || passwordText === ""
  const { login } = useApiClient()
  const handleSubmit = useCallback(
    async (adminMemberId: string, password: string) => {
      try {
        const res = await login(adminMemberId, password)
        if (res !== null) {
          router.push("/internal")
        }
      } catch (error) {
        setIsAuthFailed(true)
      }
    },
    [router, login]
  )

  return (
    <main className="flex justify-center py-32">
      <GaTag gaId={gaId} />
      <div className="w-96">
        <div className="mb-8 grid justify-items-center">
          <Image src="/QT-net.webp" width={154} height={64} alt="QT-net logo" />
        </div>

        <h1 className="text-center text-xl font-bold">QT-net法人カード管理</h1>

        <div>
          <div className="mt-8">
            <form action="#" method="POST" name="login">
              <div className="mb-2">
                <TextInput
                  name="adminMemberId"
                  id="adminMemberId"
                  data-testid="adminMemberId"
                  autoComplete="adminMemberId"
                  label="会員番号"
                  placeholder="Vから始まる11桁の英数字"
                  onChange={e => {
                    setadminMemberIdText(e.target.value)
                  }}
                  required
                />
              </div>
              <div className="my-6">
                <TextInput
                  name="password"
                  id="password"
                  data-testid="password"
                  autoComplete="current-password"
                  label="パスワード"
                  placeholder="パスワードを入力"
                  obscureText={true}
                  onChange={e => {
                    setPasswordText(e.target.value)
                  }}
                  error={
                    isAuthFailed
                      ? "アカウントIDか、パスワードが正しくありません"
                      : undefined
                  }
                  required
                />
              </div>

              <div className="my-8">
                <Button
                  data-testid="login"
                  type="submit"
                  layout="fill"
                  disabled={disabledButton}
                  onClick={e => {
                    e.preventDefault()
                    handleSubmit(adminMemberIdText, passwordText)
                  }}
                >
                  ログイン
                </Button>
              </div>
            </form>

            <div className="mt-8 grid justify-items-center text-itc-green">
              <Link href={"/internal/login/password/request-reset"}>
                <span className="align-sub font-semibold">
                  ログインにお困りの場合はこちら
                </span>
              </Link>
              <div className="mt-8 text-xs text-itc-gray-bold">
                ※
                初回ログインは、法人管理者カード（リアルカード）の送付状に記載された「会員番号」・「ログイン暗証番号（パスワード）」でログインしてください。
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default LoginPage
